import React from 'react';
import { useNotification, Notification } from '../contexts/NotificationContext';

interface NotificationItemProps {
  notification: Notification;
  onClose: () => void;
}

const NotificationItem: React.FC<NotificationItemProps> = ({ notification, onClose }) => {
  const { type, message } = notification;

  return (
    <div
      className={`notification notification--${type}`}
      role="alert"
      onClick={onClose}
    >
      <div className="notification__content">
        <span className="notification__message">{message}</span>
      </div>
      <button
        type="button"
        className="notification__close"
        onClick={(e) => {
          e.stopPropagation();
          onClose();
        }}
        aria-label="Dismiss notification"
      >
        ×
      </button>
    </div>
  );
};

const NotificationContainer: React.FC = () => {
  const { notifications, removeNotification } = useNotification();

  return (
    <div className="notification-container">
      {notifications.map((notification) => (
        <NotificationItem
          key={notification.id}
          notification={notification}
          onClose={() => removeNotification(notification.id)}
        />
      ))}
    </div>
  );
};

export default NotificationContainer;

